import { uuid } from "../../../util/basket";

export default class {
  constructor(context) {
    // Set Context
    this._context = context;

    this._cookieButton = null;

    // Initialise component
    this.init();
  }

  init() {
    // Attach event listeners to each brochure checkbox. This is only run once.
    this._cookieButton = this._context.querySelector('[data-element="cookieConfirm"]');
    if (!this._cookieButton) return;
    this._cookieButton.addEventListener('click', () => this.setCookie());
  }

  setCookie() {
    document.cookie = "cookieAcceptance=" + uuid() + "; expires=Thu, 18 Dec 2030 12:00:00 UTC; path=/";
    this._context.classList.add('hidden');
  }

}
